import React from 'react'

function Stoped() {
  return (
    <svg
      width={18}
      height={18}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        opacity={0.3}
        cx={9}
        cy={9}
        r={9}
        fill="#E59D27"
        fillOpacity={0.5}
      />
      <circle cx={9} cy={9} r={3.6} fill="#FBDC8E" />
    </svg>
  )
}

export default React.memo(Stoped)
